export default __webpack_public_path__ + "static/media/card-american.7cd7fcdf.png";